import { Injectable, Injector } from "@angular/core";
import { BaseCrudService } from "projects/ProjetoBaseAngular/domain/services/base-crud.service";
import { MetaMsgTemplateButtonModel } from "../models";

@Injectable({
  providedIn: 'root'
})
export class MetaMsgTemplateButtonService extends BaseCrudService<MetaMsgTemplateButtonModel> {

  constructor(injector: Injector) {
    super(injector);
  }

  public getController(): string {
    return 'MetaMsgTemplateButton';
  }
}
